type ButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'outline';
type ButtonSize = 'small' | 'medium' | 'large';

interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  endIcon?: React.ReactNode;
  onClick: () => void;
  size?: ButtonSize;
  startIcon?: React.ReactNode;
  variant?: ButtonVariant;
}

const variantClasses = {
  primary: 'rounded bg-primary text-primary-foreground p-2 hover:bg-primary/95 cursor-pointer',
  secondary:
    'rounded border border-ring bg-transparent p-2 text-foreground hover:bg-card cursor-pointer',
  tertiary: 'bg-transparent p-2 text-primary hover:bg-primary/5 cursor-pointer',
  outline:
    'rounded border border-primary bg-transparent p-2 text-primary hover:bg-primary/5 cursor-pointer',
};

const sizeClasses = {
  small: 'text-sm',
  medium: 'text-base',
  large: 'text-lg',
};

const disabledClasses = {
  disabled: 'opacity-50 cursor-not-allowed',
  enabled: '',
};

const Button = ({
  className = '',
  children,
  onClick,
  disabled = false,
  variant = 'primary',
  startIcon,
  endIcon,
  size = 'medium',
}: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`w-full ${variantClasses[variant]} ${sizeClasses[size]} ${disabledClasses[disabled ? 'disabled' : 'enabled']} ${className}`}
      disabled={disabled}
    >
      {startIcon && <span className="mr-2">{startIcon}</span>}
      {children}
      {endIcon && <span className="ml-2">{endIcon}</span>}
    </button>
  );
};

export default Button;
